<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button type="button" mat-raised-button class="m-1 mr-2" color="primary" (click)="onGenerateSnapshot()" matTooltip="Click this button to generate a {{ utils.getLangTerm('safety-plans.snapshots.singular', 'Snapshot') }}.">
      Generate {{ utils.getLangTerm('safety-plans.snapshots.singular', 'Snapshot') }}
    </button>
  </nav>

  <div class="alert alert-info m-3" role="alert">
      <small>{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }} {{ utils.getLangTerm('safety-plans.snapshots.plural', 'Snapshots') }} are generated in the background. You will be notified by email when it is completed.</small>
  </div>

  <mat-paginator class="my-2" #paginator1 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

  <table mat-table [dataSource]="listDataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox (change)="$event ? listDataSource.selectAllToggle() : null"
          [checked]="listDataSource.selection.hasValue() && listDataSource.isAllSelected()"
          [indeterminate]="listDataSource.selection.hasValue() && !listDataSource.isAllSelected()"
          matTooltip="Toggle select all records in this list.">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? listDataSource.selection.toggle(row.id) : null"
          [checked]="listDataSource.selection.isSelected(row.id)"
          matTooltip="Toggle select this record.">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by ID.">
        #
      </th>
      <td mat-cell *matCellDef="let snapshot">
        {{ snapshot.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="snapshot_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by name.">
        Snapshot Name
      </th>
      <td mat-cell *matCellDef="let snapshot">
        {{ snapshot.snapshot_name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by status.">
        Status
      </th>
      <td mat-cell *matCellDef="let snapshot">
        {{ snapshot.status | titlecase }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_modified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by date.">
        Last Updated At
      </th>
      <td mat-cell *matCellDef="let snapshot">
        {{ (snapshot.date_modified * 1000) | timezoneConvertLong }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_modified_UTC">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by date.">
        Last Updated At (UTC)
      </th>
      <td mat-cell *matCellDef="let snapshot">
        {{ (snapshot.date_modified * 1000) | timezoneConvertUTCLong }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let snapshot">
        <span class="badge badge-pill badge-secondary m-1" style="cursor: pointer;" *ngFor="let file of snapshot.files" (click)="utils.onDownloadFromTemporaryURL(file.url, snapshot.snapshot_name, $event)">
          {{ file.name }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
  </table>

  <mat-paginator class="my-2" #paginator2 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
</div>
